import { useConfirm } from 'components/Alert/useConfirm';
import { useMutation } from 'query';
import { reject } from 'scenes/FinancePage/SA/data/queryKeyFactory';
import { rejectSA } from 'scenes/FinancePage/SA/sources';

export const useReject = () => {
  const confirm = useConfirm();

  const approveMutation = useMutation(reject(), rejectSA, {
    refresh: true,
    successMessage: () => `Spend Adjustment rejected`,
  });

  const handleAction = ({ id }: any) => {
    confirm({
      title: `Reject Spend Adjustment ${id}?`,
      confirmActionLabel: 'Reject',
    }).then(() => approveMutation.mutateAsync({ id }));
  };

  return [handleAction, approveMutation];
};
